import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#404040'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#c00000',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontSize: 10,
        fontStyle: 'bold',
        flexGrow: 1,
        color: '#ffffff'
    },
    description: {
        width: '55%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    rate: {
        width: '12%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    amount: {
        width: '18%'
    },
  });

  const InvoiceTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.description}>ITEM DESCRIPTION</Text>
        <Text style={styles.qty}>QUANTITY</Text>
        <Text style={styles.rate}>@</Text>
        <Text style={styles.amount}>AMOUNT</Text>
    </View>
  );
  
  export default InvoiceTableHeader